import { useSentry } from '@/composables/utils/useSentry';

export const useHangError = () => {
  const { captureWabunkaException } = useSentry();
  const threeSecTimeout = ref();
  const fiveSecTimeout = ref();
  const sevenSecTimeout = ref();

  const startHangErrorTracker = () => {
    threeSecTimeout.value = setTimeout(() => {
      captureWabunkaException(new Error('createToken is hanging for 3 secs'));
    }, 3 * 1000);

    fiveSecTimeout.value = setTimeout(() => {
      captureWabunkaException(new Error('createToken is hanging for 5 secs'));
    }, 5 * 1000);

    sevenSecTimeout.value = setTimeout(() => {
      captureWabunkaException(new Error('createToken is hanging for 7 secs'));
    }, 7 * 1000);
  };

  const clearHangErrorTracker = () => {
    if (threeSecTimeout.value) {
      clearTimeout(threeSecTimeout.value);
    }
    if (fiveSecTimeout.value) {
      clearTimeout(fiveSecTimeout.value);
    }
    if (sevenSecTimeout.value) {
      clearTimeout(sevenSecTimeout.value);
    }
  };

  return {
    startHangErrorTracker,
    clearHangErrorTracker,
  };
};
